"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _templateObject;
var QuoteStyles = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding: 20px;\n  font-family: var(--bf-lead-font);\n\n  @media (min-width: ", ") {\n    padding: 24px;\n  }\n\n  .block {\n    padding-left: 20px;\n    border-left: 1px solid var(--bf-op15-core-gray);\n\n    .quote {\n      color: var(--bf-core-pink);\n      font-size: 30px;\n      line-height: 36px;\n      padding: 20px 0;\n\n      @media (min-width: ", ") {\n        font-size: 40px;\n        line-height: 48px;\n      }\n    }\n\n    .caption {\n      color: var(--bf-op70-core-black);\n      font-size: 11px;\n      line-height: 20px;\n\n      @media (min-width: ", ") {\n        font-size: 12.8px;\n      }\n    }\n  }\n"])), _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.s);
var Quote = function Quote(_ref) {
  var caption = _ref.caption,
    text = _ref.text,
    children = _ref.children;
  return _react.default.createElement(QuoteStyles, null, _react.default.createElement("div", {
    className: "block"
  }, _react.default.createElement("div", {
    className: "quote"
  }, text || children), _react.default.createElement("div", {
    className: "caption"
  }, caption)));
};
var _default = Quote;
exports.default = _default;